import { sortTypes, sortValues } from '@jetshop/core/components/SortOrder/SortOrderContainer';
import SortOrderContext from '@jetshop/core/components/SortOrder/SortOrderContext';
import * as React from 'react';
export function useSortOrder({ sortOrders }) {
    // Mutate sort order obj to include asc/desc & appropriate text
    // eg { text: 'Price low to high', direction: 'ASCENDING' }
    const { changeSortOrder, direction, sortOrder } = React.useContext(SortOrderContext);
    const mappedSortOrder = sortOrders.reduce((sorts, curr) => {
        const mutatedSorts = sortValues[sortTypes[curr.value]].map(type => {
            return Object.assign(Object.assign({}, curr), { text: (React.createElement("span", null,
                    curr['text'],
                    " ",
                    type.text)), direction: type.direction });
        });
        return [...sorts, ...mutatedSorts];
    }, []);
    return { changeSortOrder, direction, sortOrder, mappedSortOrder };
}
//# sourceMappingURL=useSortOrder.js.map